import { render, staticRenderFns } from "./altStats.vue?vue&type=template&id=6b710858&scoped=true"
import script from "./altStats.vue?vue&type=script&lang=js"
export * from "./altStats.vue?vue&type=script&lang=js"
import style0 from "./altStats.vue?vue&type=style&index=0&id=6b710858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b710858",
  null
  
)

export default component.exports